import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormGroup,
  FormText,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import axiosConfig from "consts/axiosConfig";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { registerRs } from "consts/Constants";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Swal from "sweetalert2";
import { removeFromArray } from "consts/Constants";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";

const schema = yup
  .object({
    title: yup.string().required(),
    employment_type: yup.string().nullable(),
    company_name: yup.string().nullable(),
    active: yup.boolean().required(),
    description: yup.string().nullable(),
    location: yup.string().nullable(),
    image: yup.mixed().nullable(),
  })
  .required();
export default function UserExperienceModal(props) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [skills, setSkills] = useState([]);
  const onSubmit = (data) => {
    data.start = moment(
      startDate.year + "-" + startDate.month + "-" + startDate.day
    ).format("yyyy-MM-DD");
    data.end = moment(
      endDate.year + "-" + endDate.month + "-" + endDate.day
    ).format("yyyy-MM-DD");
    var url = props.url_perfix + "experiences_store";
    if (props.currentModel?.id) {
      url = props.url_perfix + "experiences_update/" + props.currentModel.id;
    }
    let formData = new FormData();

    data.skills = skills.length ? JSON.stringify(skills) : null;
    for (var prop in data) {
      if (prop === "image") {
        console.log(data);
        formData.append("image", data.image ? data.image[0] : null);
      } else {
        formData.append(prop, data[prop]);
      }
    }
    setLoading(true);
    axiosConfig
      .post(url, formData, {
        "Content-Type": "multipart/form-data",
      })
      .then((res) => {
        if (!res.data.hasError) {
          props.toggleModal(false);
          props.getProfile();
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    reset(props?.currentModel);
    setStartDate(
      props?.currentModel.start && props?.currentModel.start !== "0000-00-00"
        ? {
            year: parseInt(moment(props?.currentModel.start).format("YYYY")),
            month: parseInt(moment(props?.currentModel.start).format("MM")),
            day: parseInt(moment(props?.currentModel.start).format("DD")),
          }
        : null
    );
    setEndDate(
      props?.currentModel.end && props?.currentModel.end !== "0000-00-00"
        ? {
            year: parseInt(moment(props?.currentModel.end).format("YYYY")),
            month: parseInt(moment(props?.currentModel.end).format("MM")),
            day: parseInt(moment(props?.currentModel.end).format("DD")),
          }
        : null
    );
    setSkills(
      props.currentModel.skills ? JSON.parse(props.currentModel.skills) : ""
    );
  }, [props.currentModel, reset]);
  const createInputs = (
    name,
    label,
    placeHolder,
    type = "text",
    disabled = false
  ) => {
    return (
      <FormGroup>
        <label className="form-control-label" htmlFor={`input-${name}`}>
          {label}
        </label>
        <Input
          id={`input-${name}`}
          placeholder={placeHolder}
          type={type}
          disabled={loading || disabled}
          {...registerRs(name, register)}
        />
        <FormText color="danger">{errors[name]?.message}</FormText>
      </FormGroup>
    );
  };

  const addSkillSwal = async () => {
    const { value: skill } = await Swal.fire({
      title: "Skill",
      input: "text",
      inputLabel: "Skill",
      inputPlaceholder: "Enter...",
    });
    if (skill) {
      setSkills([...skills, skill]);
    }
  };
  const removeItem = (item, setNewItem, items) => {
    setNewItem(removeFromArray(items, item));
  };
  const renderItems = (items, setNewItem) => {
    if (items.length) {
      return items.map((item) => {
        return (
          <div
            className="d-flex flex-row jc-space-between ai-center multiple-tag"
            key={item}
          >
            <span>{item}</span>
            <i
              className="fa fa-times"
              onClick={() => removeItem(item, setNewItem, items)}
            />
          </div>
        );
      });
    }
  };
  return (
    <Modal isOpen={props.showModal}>
      <ModalHeader>{props.title}</ModalHeader>
      <Form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <ModalBody>
          <Row>
            <Col>{createInputs("title", "Title", "Title")}</Col>
            <Col>
              {createInputs(
                "employment_type",
                "Employment Type",
                "Employment Type"
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              {createInputs("company_name", "Company Name", "Company Name")}
            </Col>
            <Col>{createInputs("location", "Location", "Location")}</Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <label className="form-control-label" htmlFor={`input-start`}>
                  Start Date
                </label>
                <DatePicker
                  value={startDate}
                  onChange={setStartDate}
                  shouldHighlightWeekends
                  wrapperClassName="form-control"
                  inputPlaceholder=" "
                  calendarPopperPosition="bottom"
                  formatInputText={() =>
                    startDate
                      ? moment(
                          startDate.year +
                            "-" +
                            startDate.month +
                            "-" +
                            startDate.day
                        ).format("yyyy-MM-DD")
                      : ""
                  }
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <label className="form-control-label" htmlFor={`input-start`}>
                  End Date
                </label>
                <DatePicker
                  value={endDate}
                  onChange={setEndDate}
                  shouldHighlightWeekends
                  wrapperClassName="form-control"
                  inputPlaceholder=" "
                  calendarPopperPosition="bottom"
                  formatInputText={() =>
                    endDate
                      ? moment(
                          endDate.year + "-" + endDate.month + "-" + endDate.day
                        ).format("yyyy-MM-DD")
                      : ""
                  }
                />
              </FormGroup>
            </Col>
          </Row>
          {createInputs(
            "description",
            "Description",
            "Description",
            "textarea"
          )}

          <FormGroup>
            <label className="form-control-label" htmlFor="input-active">
              Active
            </label>
            <Input
              id="input-active"
              type="select"
              disabled={loading}
              {...registerRs("active", register)}
            >
              <option value={1}>Yes</option>
              <option value={0}>No</option>
            </Input>
            <FormText color="danger">{errors.active?.message}</FormText>
          </FormGroup>
          <FormGroup>
            <label className="form-control-label">Skills</label>
            <Button
              size="sm"
              color="link"
              className="ml-2"
              onClick={() => {
                addSkillSwal();
              }}
            >
              Add Skill
            </Button>
            <br />
            <div className="d-flex flex-row flex-wrap">
              {renderItems(skills, setSkills)}
            </div>
          </FormGroup>
          <FormGroup>
            <label className="form-control-label" htmlFor="input-image">
              Image
            </label>
            <Input
              id="input-image"
              placeholder="image"
              type="file"
              accept="image/*"
              disabled={loading}
              {...registerRs("image", register)}
            />

            <FormText color="danger">{errors.image?.message}</FormText>
          </FormGroup>
        </ModalBody>
        {loading ? (
          <ModalFooter>
            <div
              className="d-flex ai-center jc-center"
              style={{ width: "100%" }}
            >
              <Spinner animation="border" />
            </div>
          </ModalFooter>
        ) : (
          <ModalFooter>
            <Button color="secondary" onClick={() => props.toggleModal(false)}>
              Discard
            </Button>
            <Button disabled={loading} color="primary" type="submit">
              Save
            </Button>
          </ModalFooter>
        )}
      </Form>
    </Modal>
  );
}
